var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"begin-date"},[_c('b',[_vm._v("Desde:")]),_vm._v(" "+_vm._s(_vm.beginDate))]),_c('div',{class:[_vm.isUndefined ? 'red-date' : 'end-date']},[_c('b',[_vm._v("Hasta:")]),_vm._v(" "+_vm._s(_vm.endDate))])])
}
var staticRenderFns = []

export { render, staticRenderFns }